<template>
  <n-modal v-bind="$props">
    <!-- prettier-ignore -->
    <Form ref="modalForm" :model="model" :label-width="labelWidth" class="n-modal-container" @submit.native.prevent>
      <n-row-col2>
        <!-- id -->
        <n-field-id v-model="model.id" field-name="id" label="id" :error="error.id" :disabled="true" />
        <!-- cohortId -->
        <n-field-text v-model="model.cohortId" field-name="cohortId" label="cohortId" :error="error.cohortId" :disabled="disabled" />
      </n-row-col2>
    </Form>
  </n-modal>
</template>
<script>
import { DATE_FORMAT } from '@/constant/format';
import NModal from '@/components/common/NModal';
import { add, validate } from '@/api/company/company-cohort';

export default NModal.extend({
  name: 'ModalCampaignCohort',
  components: { NModal },

  data() {
    return {
      DATE_FORMAT,
    };
  },

  methods: {
    doSubmit(model) {
      return add(model);
    },

    doValidate(model) {
      return validate(model);
    },
  },
});
</script>
